import type { SignupOffer } from '@promotion/types'
import type { SignupContainerData } from '#types'

export const useSignupContainer = createSharedComposable(() => {
    const route = useRoute()
    const { data: authContainerData, step } = useAuthContainer()
    const { defaultSignupPromotion, signupPromotions } = useSignupPromotions()

    const data = ref<SignupContainerData>({
        User: {
            name: '',
            first_name: '',
            last_name: '',
            terms: true,
            birthdate: '',
            newsletter: false,
            sms: false,
            privacy_policy: true,
            consentTexts: {},
            phone: '',
            address: '',
            city: '',
            zipcode: ''
        },
    })

    const birthdateValueFormat = ref('DD/MM/YYYY')
    watch(() => data.value.User.birthdate, (newValue: string) => {
        const defaultFormat = 'DD/MM/YYYY'

        birthdateValueFormat.value = defaultFormat.slice(newValue.length, defaultFormat.length)
    })

    function togglePromotion(promotion?: SignupOffer) {
        const promotionId: string | false = authContainerData.value.selectedPromotion === promotion?.id ? false : promotion?.id || false

        authContainerData.value.selectedPromotion = promotion?.id || defaultSignupPromotion.value?.id
        authContainerData.value.promotionAccepted = promotionId ? true : false
    }

    const terms = computed(() => signupPromotions.value.map((promotion: SignupOffer) => {
        return {
            title: promotion.title,
            label: promotion.label,
            text: promotion.longTerms
        }
    }))

    watch(() => route.query.step, async (newStep, oldStep) => {
        if (!newStep) {
            // Auth has left the URL (Back) while the sheet animates out: the step must not be put back.
            if (route.query.auth !== 'signup') return

            await nextTick()

            await navigateTo({
                query: {
                    ...route.query,
                    step: Number(step.value)
                }
            })

            return
        }

        step.value = Number(newStep)
    }, {
        immediate: true
    })

    return {
        birthdateValueFormat,
        togglePromotion,
        data,
        terms,
    }
})
